import { client } from "@/http/client"

import { IPagingResponse, IRequestParams, IResponse } from "@/types/api"
import { IDownloadDocument } from "@/types/IDownloadDocument"
import { IOrderReport, IOrderReportOption } from "@/types/IOrderReport"
import { ITableColumn } from "@/types/ui"

export const getOrderReport = (
  params?: IOrderReportOption
): Promise<IPagingResponse<IOrderReport>> =>
  client.get("/OrderReports", {
    params
  })

export const getOrderReportExcel = (
  params: IRequestParams,
  columns?: ITableColumn<IOrderReport>[]
): Promise<IResponse<IDownloadDocument>> =>
  client.post("/OrderReports/Excel", columns, {
    params
  })
